module.exports = __webpack_public_path__ + "static/media/img_feature_photo1@2x.8c75621b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_feature_photo1@2x.webp
// module id = 794
// module chunks = 0